export default __webpack_public_path__ + "static/media/IMG_9394.1eb1471a.jpg";